<div class="ivd">
  <div class="ivd__grid">
    @for (slot of slotViews; track slot.key) {
      <div class="ivd__col">
        <!-- Top bar: slot label + actions menu -->
        <div class="ivd__bar">
          <span class="s26-label">{{ slot.label }}</span>

          <input
            #fileInput
            type="file"
            accept="image/*"
            style="display: none"
            (change)="uploadDocument(slot.key, $event)"
          />

          <itfg-mat-tab-menu class="ivd__menu-btn">
            <div trigger>
              <mat-icon>more_horiz</mat-icon>
            </div>
            <div content>
              <button mat-menu-item (click)="fileInput.click()" [disabled] = "true">
                <mat-icon>upload</mat-icon>
                <span>{{
                  'verification.id.documentActions.upload' | translate
                }}</span>
              </button>
              <button
                mat-menu-item
                [disabled]="!slot.documentId"
                (click)="downloadDocument(slot.documentId, slot.key)"
              >
                <mat-icon>download</mat-icon>
                <span>{{
                  'verification.id.documentActions.download' | translate
                }}</span>
              </button>
              <button
                mat-menu-item
                [disabled]="!slot.documentId"
                (click)="rotateDocument(slot.documentId, slot.key, true)"
              >
                <mat-icon>rotate_right</mat-icon>
                <span>{{
                  'verification.id.documentActions.rotateClockwise' | translate
                }}</span>
              </button>
              <button
                mat-menu-item
                [disabled]="!slot.documentId"
                (click)="rotateDocument(slot.documentId, slot.key, false)"
              >
                <mat-icon>rotate_left</mat-icon>
                <span>{{
                  'verification.id.documentActions.rotateCounterClockwise'
                    | translate
                }}</span>
              </button>
              <button
                mat-menu-item
                [disabled]="!slot.documentId"
                (click)="deleteDocument(slot.documentId, slot.key)"
              >
                <mat-icon color="warn">delete</mat-icon>
                <span class="ivd__action--danger">{{
                  'verification.id.documentActions.delete' | translate
                }}</span>
              </button>
            </div>
          </itfg-mat-tab-menu>
        </div>

        <!-- Document viewer -->
        <div class="ivd__viewer-wrap">
          <itfg-identity-document-viewer
            [client]="client"
            [documentType]="SLOT_CONFIGS[slot.key].apiType"
            [selectedDocId]="slot.documentId"
            [docList]="docList"
            [loading]="loading"
            [loadingList]="loading"
          ></itfg-identity-document-viewer>
        </div>
      </div>
    }
  </div>
</div>